export default __webpack_public_path__ + "static/media/spinner.081a5d5f.svg";